import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-kit';
import { BUTTON_TYPES } from '_constants';
import * as Styled from '../styles';

// Shown when the user returns (after re-login) to a survey they had partly
// filled. They choose to continue from the autosaved draft or discard it and
// start fresh. Dismissing the modal (backdrop / escape) defaults to the safe
// choice — continue — so an accidental dismiss never throws away their answers.
function DraftRecoveryModal({ isOpen, onContinue, onStartFresh, formName, savedAt }) {
  const savedAtLabel = savedAt ? new Date(savedAt).toLocaleString() : '';

  return (
    <Modal open={isOpen} onClose={onContinue} autoHeight>
      <Styled.CompactModalWrapper>
        <Styled.ModalTitle>Continue your unsaved survey?</Styled.ModalTitle>
        <Styled.ModalDescription as="p" style={{ listStyle: 'none', padding: 0 }}>
          {`You have an unsaved draft${formName ? ` of "${formName}"` : ''}${
            savedAtLabel ? ` from ${savedAtLabel}` : ''
          }. Continue where you left off, or start fresh?`}
        </Styled.ModalDescription>
        <Styled.ModalButtonWrapper>
          <Styled.ModalButtonCancel
            onClick={onStartFresh}
            text="Start fresh"
            variant={BUTTON_TYPES.DARK}
            aria-label="Start fresh"
          />
          <Styled.ModalButtonSet
            onClick={onContinue}
            text="Continue draft"
            variant={BUTTON_TYPES.DANGER}
            aria-label="Continue draft"
          />
        </Styled.ModalButtonWrapper>
      </Styled.CompactModalWrapper>
    </Modal>
  );
}

DraftRecoveryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
  onStartFresh: PropTypes.func.isRequired,
  formName: PropTypes.string,
  savedAt: PropTypes.string,
};

DraftRecoveryModal.defaultProps = {
  formName: '',
  savedAt: '',
};

export default DraftRecoveryModal;
